import styled from 'styled-components/macro';

export const HeadingHolder = styled.div`
  width: 100%;
  padding: 15px;
  color: var(--white);
  background: var(--darkMosGreen);
`;
export const BtnHolder = styled.div`
  text-align: center;
`;
